/* eslint-disable react-hooks/exhaustive-deps */
import { produce } from 'immer';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import useBreakpoints from '../../../../../../common/hooks/useBreakpoints';
import { ProductListModel } from '../../../../models/Product';
import {
  FilterPanelModel,
  ProductListState,
} from '../../../CategoryPage/types';
import { getSortedProduts } from '../../../CategoryPage/utils';
import MobileProductsComponent from './MobileSearchResults';
import { getProductIdentifier, getQueryParams } from '../../utils';

interface IMobileSearchProps {
  searchProducts: ProductListState;
  setSearchProducts: Dispatch<SetStateAction<ProductListState>>;
  filters: FilterPanelModel;
}

const MobileSearchContent = (props: IMobileSearchProps) => {
  const location = useLocation();
  const entityIdentifier = getProductIdentifier(getQueryParams());
  const searchResult = (location.state as { searchRes: ProductListModel[] })
    ?.searchRes;

  const { isTablet } = useBreakpoints();
  const { searchProducts, setSearchProducts, filters } = props;

  const [searchValue, setSearchValue] = useState<string | undefined>();
  const hasResults = !!searchProducts.filtredProductList?.length;

  const handleSortingOrderChanged = (id: number) => {
    setSearchProducts(
      produce(draft => {
        draft.filtredProductList = getSortedProduts[id](
          draft.filtredProductList,
        );
      }),
    );
  };

  useEffect(() => {
    if (isTablet) {
      if (entityIdentifier?.name) setSearchValue(entityIdentifier.name);
      !!searchResult &&
        setSearchProducts({
          productList: searchResult,
          filtredProductList: searchResult,
        });
    }
  }, [searchResult, entityIdentifier?.name]);

  return (
    <div
      className={`mobile-search-container ${
        hasResults ? 'with-results' : ''
      }`.trim()}
    >
      {hasResults && (
        <MobileProductsComponent
          filteredProducts={searchProducts.filtredProductList}
          searchValue={searchValue}
          handleSortingOrderChange={handleSortingOrderChanged}
          filters={filters}
          isTabletView={isTablet}
          isDiscountVoucherList={false}
          isBenefitBucksList={false}
        />
      )}
    </div>
  );
};

export default MobileSearchContent;
